
import { computed, defineComponent, ref } from "vue";
import BillingInfo from "./BillingInfo.vue";
import LoadingModal from "./LoadingModal.vue";
import StatusBlock from "./StatusBlock.vue";
import CollapsableContainer from "./CollapsableContainer.vue";
import { States, submitHandler } from "./submit_handler";
import { useUserStore } from "@/store/user";

export default defineComponent({
  components: { BillingInfo, CollapsableContainer, LoadingModal, StatusBlock },
  emits: {
    toggleSubChangeBlock: null,
    toggleBillingInfoChangeBlock: null,
  },
  setup() {
    const user = useUserStore();
    let states: States = {
      recaptcha: null,
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: false,
    };

    function montlyOrAnnual() {
      if (user.subscription?.plan?.name) {
        return user.subscription.plan.name === "OTC PRO ANNUAL"
          ? "YEARLY"
          : "MONTHLY";
      }
    }
    function cancelSubscription() {
      submitHandler(user.cancelSubscription(), states);
    }
    function reactivateSubscription() {
      submitHandler(user.reactivateSubscription(), states);
    }

    let totalAmountFormatted = computed(() => {
      return user.subscription?.unitAmount ? `$${(user.subscription.unitAmount / 100).toFixed(2)}` : null;
    });

    return {
      loadingShow: states.loadingShow,
      errorMessage: states.errorMessage,
      montlyOrAnnual,
      cancelSubscription,
      reactivateSubscription,
      user,
      totalAmountFormatted
    };
  },
});
